import { PhotoCamera, Save, Cancel } from "@material-ui/icons";
import React, { useState, useRef, useEffect } from "react";
import { resizeImage, uploadFilesToFilestorage } from "../utils/media-files";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { USER_HAS_PICTURE } from "../constants";
import { Avatar, Grid, IconButton } from "@material-ui/core";

interface ImageProfileCircleProps {
  width: string;
  height: string;
  userId?: string | number;
  userName?: string;
  uploadOption?: boolean;
  ruc: string;
}

export function getAvatarColor(name: string): string {
  const colors = [
    "#FF5722", "#4CAF50", "#FFC107", "#2196F3", "#9C27B0", "#FF9800", "#009688", "#3F51B5", "#E91E63", "#673AB7"
  ];
  const initials = name
    .split(' ')
    .map(word => word.toUpperCase().charCodeAt(0))
    ;
  const sum = initials.reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);
  const hash = sum % colors.length;
  return colors[hash];
}

const ImageProfileCircle = (props: ImageProfileCircleProps) => {
  const dispatch = useDispatch<any>();
  const {companyselected, userHasProfilePicture, usersWithoutProfilePicture} = useSelector((state: any) => state.auth);
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string | undefined>();
  const [uploading, setUploading] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const inputFileRef = useRef<HTMLInputElement>(null);
//   const [errorMsg, setErrorMsg] = useState("");
  const isLoggedUser = `${companyselected?.Code}` === `${props.userId}`;

  useEffect(() => {
    if (!isLoggedUser) {
        return;
    }
    getUserUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userHasProfilePicture])

  useEffect(() => {
    if (!props?.userId || isLoggedUser) {
        return;
    }
    getUserUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userId])


  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
        setShowButtons(true);
        setImage(file)
        // const reader = new FileReader();
        // reader.onloadend = () => {
        //     setImage(reader.result as string);
        // }
        // reader.readAsDataURL(file);
    } else {
        setShowButtons(false);
    }
  };

  const getImagePath = () =>`PROFILE-PICTURE/USER-${props.userId}/`
  // 60000000001/PROFILE-PICTURE/USER-04010003/SMALL.jpeg
  // https://s10-fs-prod-files.s3.amazonaws.com/60000000001/PROFILE-PICTURE/USER-04010003/SMALL.jpeg
  const handleSave = async () => {
    if (!image || !companyselected) {
        return;
    }
    setUploading(true);
    try {
        const resizedImages = await resizeImage(image);
        const allFiles = resizedImages; //  [...resizedImages, image]
        const filesId = allFiles.map((f: any) => `${getImagePath()}${f.name.split(".")[0]}`);
        await uploadFilesToFilestorage(
                allFiles,
                // setErrorMsg,
                () => {},
                false,
                "",
                false,
                filesId,
            );
        dispatch({
            type: USER_HAS_PICTURE,
            payload: true
        });
    } catch (error) {
        console.error("Error al subir la imagen:", error);
        // setErrorMsg("Error al subir la imagen");
    } finally {
        setUploading(false);
        setShowButtons(false);
    }
  };

  const handleCancel = () => {
    setImage(null); // Restablecer la imagen a la que se muestra por defecto
    setShowButtons(false);
  };

  const generateUserProfileImageUrl = () => {
    const bucket = 'https://s10-fs-prod-files.s3.amazonaws.com';
    return `${bucket}/${props.ruc}/${getImagePath()}SMALL.jpeg?uuid=${uuidv4()}`;
  }

  const getUserUrl = async () => {
    if (isLoggedUser) {
        if (userHasProfilePicture !== false) {
          setImageUrl(generateUserProfileImageUrl())
        }
    } else {
        if (!usersWithoutProfilePicture?.includes(`${props.userId}`)) {
          setImageUrl(generateUserProfileImageUrl())
        }
    }
  }

  return (
    <Grid
        key={`${props.userId}${isLoggedUser ? userHasProfilePicture : ''}`}
        item
        style={{
            width: props.width,
            height: props.height || undefined,
            maxHeight: props.width,
            borderRadius: "50%",
            border: `1px solid #3C8DBC`,
            position: 'relative',
        }}
    >
        <Avatar
            key={`${props.userId}${isLoggedUser ? userHasProfilePicture : ''}`}
            style={{
                backgroundColor: props.userName ? getAvatarColor(props.userName) : "gray",
                borderRadius: "50%",
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
                border: `1px solid white`,
                cursor: props.uploadOption ? 'pointer' : 'default'
            }}
            src={
                props.uploadOption && image 
                    ? URL.createObjectURL(image) 
                    : imageUrl
            }
            onError={({ currentTarget }: any) => {
                currentTarget.onerror = null;
                // (currentTarget as any).src = '#';
                dispatch({
                    type: USER_HAS_PICTURE,
                    payload: false
                });
            }}
            alt={props.userName}
            // onClick={handleImageClick}
        >
            {props.userName
            ? props.userName[0].toUpperCase()
            : undefined}
        </Avatar>

        {props.uploadOption && showButtons && (
            <Grid 
                container
                justifyContent="space-between"
                style={{
                    position: 'absolute',
                    bottom: -10,
                    width: "100%",
                    //   left: '50%',
                    //   transform: 'translateX(-50%)',
                    display: 'flex',
                    alignItems: 'center',
                    zIndex: 1000,
                }}
            >   
                <Grid item>
                    <IconButton
                        onClick={handleSave} 
                        disabled={uploading} 
                        // color="success"
                    >
                        <Save />
                    </IconButton>
                </Grid>
                <Grid item>
                    <IconButton 
                        onClick={handleCancel}
                        // color="error"
                    >
                        <Cancel />
                    </IconButton>
                </Grid>
            </Grid>
        )}

        {props.uploadOption && !showButtons && (
            <div style={{
                position: 'absolute',
                height: "2rem",
                width: "2rem",
                bottom: 10,
                right: 10,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '50%',
                padding: 5,
                cursor: 'pointer'
                }}
            >
            <label htmlFor="image-upload"> {/* Se agrega htmlFor */}
                <PhotoCamera style={{ color: 'white' }} />
            </label>
            <input
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                id="image-upload"
                ref={inputFileRef}
                onChange={handleImageUpload}
            />
            </div>
        )}
    </Grid>
  )
}

export default ImageProfileCircle;